export default __webpack_public_path__ + "static/media/Comp 2_00032.8e7ac00e.png";